import React from 'react'

const RadioButtonGroup = ({label, className = '', classNameWrapper = '', children, info='', description='', fieldsetChildren = false}) => (
  <div className={"input-field " + className}>
    <fieldset>
      <legend>
        {label}
        {info && <span className="label-info text-small-regular">{info}</span>}
        {description && <p className="label-description text-small-light">{description}</p>}
      </legend>

      <div className="radio-button-wrapper">
        <div className="radio-button-group-wrapper">
          {children}
        </div>
        
        {fieldsetChildren && fieldsetChildren}
      </div>
    </fieldset>
  </div>
)
 
export default RadioButtonGroup